import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import React from "react";
import { Pressable, StyleSheet, TextInput, View } from "react-native";

const classes = StyleSheet.create({
  root: {
    width: "100%",
  },
  body: {
    margin: 10,
    padding: 10,
    gap: 10,
    backgroundColor: theme.color.grey,
    borderRadius: 6,
    color: theme.color.darkGrey,
    flexDirection: "row",
    alignContent: "center",
    elevation: 2,
    shadowColor: "#000",
    shadowOpacity: 0.2,
    shadowRadius: 2,
    shadowOffset: { width: 0, height: 1 },
  },
  iconContainer: {
    justifyContent: "center",
  },
  searchInput: {
    flexBasis: "80%",
    color: theme.color.darkGrey,
  },
});

export default function SearchBar(props) {
  const { placeholder = "Search...", value, onChangeText } = props;

  return (
    <View style={classes.root}>
      <View style={classes.body}>
        <View style={classes.iconContainer}>
          <Icon
            name="magnify"
            size={theme.icon.size.medium}
            color={theme.color.backgroundText}
          />
        </View>
        <TextInput
          value={value}
          placeholder={placeholder}
          onChangeText={onChangeText}
          style={classes.searchInput}
        />
        {!!value?.length && (
          <Pressable
            onPress={() => onChangeText("")}
            style={classes.iconContainer}
          >
            <Icon
              name="close"
              size={theme.icon.size.medium}
              color={theme.color.backgroundText}
            />
          </Pressable>
        )}
      </View>
    </View>
  );
}
